import { apiFetch } from '../client';

export function fetchHistoric(data){
    return apiFetch(`/price-api/historic-prices/`, {
        method: 'POST',
        body: JSON.stringify(data)
    })
}

export function fetchPulp(data){
    return apiFetch(`/price-api/v2/pulp/?muni=${data.muni}`, {
        method: 'GET'
    })
}

export function fetchTimber(data){
    return apiFetch(`/price-api/v2/timber/?muni=${data.muni}`, {
        method: 'GET'
    })
}

export function virkespriserPost(data) {
    let formData = new FormData();

    
    formData.append("muni", data.muni)
    formData.append("volume", data.volume)
    formData.append("anbudManuellt", data.anbudManuellt ? data.anbudManuellt : "")
    formData.append("email", data.email)
    formData.append("phonenumber", data.phonenumber)
    formData.append("anbudsDatum", data.anbudsDatum)

    data.anbud.forEach((a) => {
        formData.append('file', a.file);
    })

    return apiFetch('/submit-to-anbudskollen/', {
        method: 'POST',
        body: formData,
        headers: {}
    })
}
